import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function PaymentPage() {
    const [searchParams] = useSearchParams();
    const [ready, setReady] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const sessionId = searchParams.get("session");

    useEffect(() => {
        if (!sessionId) return;

        const script = document.createElement("script");
        script.src = "https://mtf.gateway.mastercard.com/static/checkout/checkout.min.js";
        script.setAttribute("data-error", "errorCallback");
        script.setAttribute("data-cancel", "cancelCallback");

        script.onload = () => {
            setReady(true);
        };

        document.body.appendChild(script);

        window.errorCallback = function (error) {
            alert("Payment Error ❌");
            console.log(error);
        };

        window.cancelCallback = function () {
            alert("Payment Cancelled ❌");
        };
    }, [sessionId]);

    const startPayment = () => {
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions");
            return;
        }

        if (!window.Checkout || !sessionId) {
            alert("Payment not ready");
            return;
        }

        window.Checkout.configure({
            session: {
                id: sessionId
            }
        });

        window.Checkout.showPaymentPage();
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h2 style={styles.title}>
                    🔒 Secure Payment Gateway
                </h2>

                <p style={styles.desc}>
                    Your payment is encrypted and securely processed through Mastercard Payment Gateway Services.
                </p>

                {/* Checkbox */}
                <div style={styles.checkboxRow}>
                    <input
                        type="checkbox"
                        checked={accepted}
                        onChange={() => setAccepted(!accepted)}
                    />
                    <label style={styles.label}>
                        I agree to the{" "}
                        <Link to="/terms-conditions" style={styles.link}>
                            Terms & Conditions
                        </Link>{" "}
                        and{" "}
                        <Link to="/privacy-policy" style={styles.link}>
                            Privacy Policy
                        </Link>
                    </label>
                </div>

                {/* Button */}
                <button
                    onClick={startPayment}
                    disabled={!ready}
                    style={{
                        ...styles.button,
                        opacity: ready ? 1 : 0.6,
                        cursor: ready ? "pointer" : "not-allowed"
                    }}
                >
                    {ready ? "Proceed to Secure Payment" : "Preparing Secure Checkout..."}
                </button>
            </div>
        </div>
    );
}

const styles = {
    page: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #fff7f3 0%, #ffffff 50%, #fff1eb 100%)"
    },
    card: {
        background: "#fff",
        padding: "40px",
        borderRadius: "24px",
        border: "1px solid rgba(255,107,53,0.15)",
        boxShadow: "0 20px 50px rgba(255,107,53,0.12)",
        width: "420px",
        textAlign: "center"
    },
    title: {
        marginBottom: "10px",
        color: "#FF6B35",
        fontWeight: "700",
        fontSize: "28px"
    },
    desc: {
        fontSize: "14px",
        color: "#666",
        marginBottom: "20px"
    },
    checkboxRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        textAlign: "left",
        marginBottom: "20px"
    },
    label: {
        fontSize: "13px",
        color: "#555",
        lineHeight: "1.5"
    },
    link: {
        color: "#FF6B35",
        fontWeight: "600",
        textDecoration: "none"
    },
    button: {
        width: "100%",
        padding: "14px",
        background: "linear-gradient(90deg, #FF6B35 0%, #FF8C42 100%)",
        color: "#fff",
        border: "none",
        borderRadius: "12px",
        fontSize: "16px",
        fontWeight: "600",
        boxShadow: "0 10px 25px rgba(255,107,53,0.25)"
    }
};